((app, ng) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("errorModalCtrl", ["$scope", "$mdDialog", "message",
        ($scope, $mdDialog, message) => {
        let $ctrl = {};
        $scope.$ctrl = $ctrl;
        $ctrl.isArray = ng.isArray;

        $ctrl.$onInit = async () => {
            $ctrl.message = message;
        };
        $ctrl.$onInit();

        $ctrl.close = () => {
            $mdDialog.cancel();
        };
    }]);
})(window.app, window.angular);
